const AREA=[[
  { value: 'Empresas de Marketing o Analítica de mercado para CPGs', label: 'Marketing or Market Analytics Companies for CPGs' },
  { value: 'Empresas especializadas en servicios/consultoría para el sector del retail', label: 'Companies specialized in services/consulting for the retail sector' },
  { value: 'Empresas especializadas en servicios de inteligencia de negocios y analítica avanzada', label: 'Companies specialized in business intelligence and advanced analytics services' },
  { value: 'Empresas que provean soluciones relacionadas a sellin, sellout, inventarios, precios, etc. del sector retail', label: 'Companies providing solutions related to retail sell-in, sell-out, inventories, prices, etc.' },
  {value:'Empresas del sector retail que vendan productos en portales e-commerce',label:'Retail sector companies that sell products on e-commerce portals'},
  { value: 'Otro', label: 'Other' },
],[{value:'Empresas de Marketing o Analítica de mercado para CPGs',label:'Empresas de Marketing o Analítica de mercado para CPGs',},
{value:'Empresas especializadas en servicios/consultoría para el sector del retail',label:'Empresas especializadas en servicios/consultoría para el sector del retail',},
{value:'Empresas especializadas en servicios de inteligencia de negocios y analítica avanzada',label:'Empresas especializadas en servicios de inteligencia de negocios y analítica avanzada',},
{value:'Empresas que provean soluciones relacionadas a sellin, sellout, inventarios, precios, etc. del sector retail',label:'Empresas que provean soluciones relacionadas a sellin, sellout, inventarios, precios, etc. del sector retail',},
{value:'Empresas del sector retail que vendan productos en portales e-commerce',label:'Empresas del sector retail que vendan productos en portales e-commerce',},
{value:'Otro',label:'Otro',},]]


const POSITION=[[
  { value: 'Analista', label: 'Analyst' },
  { value: 'Category Manager', label: 'Category Manager' },
  { value: 'Cuenta Clave', label: 'Key Account Manager' },
  { value: 'Desarrollador', label: 'Developer' },
  { value: 'Director', label: 'Director' },
  { value: 'Gerente', label: 'Manager' },
  { value: 'Líder de Campo', label: 'Field Leader' },
  { value: 'Promotor', label: 'Promoter' },
  { value: 'Resurtidor / CPFR', label: 'Replenisher / CPFR' },
  { value: 'Técnico de Campo', label: 'Field Technician' },
  { value: 'Supervisor', label: 'Supervisor' },
  { value: 'Otro', label: 'Other' }
],[
    { value: 'Analista', label: 'Analista' },
    { value: 'Category Manager', label: 'Category Manager' },
    { value: 'Cuenta Clave', label: 'Cuenta Clave' },
    { value: 'Desarrollador', label: 'Desarrollador' },
    { value: 'Director', label: 'Director' },
    { value: 'Gerente', label: 'Gerente' },
    { value: 'Líder de Campo', label: 'Líder de Campo' },
    { value: 'Promotor', label: 'Promotor' },
    { value: 'Resurtidor / CPFR', label: 'Resurtidor / CPFR' },
    { value: 'Técnico de Campo', label: 'Técnico' },
    { value: 'Supervisor', label: 'Supervisor' },
    { value: 'Otro', label: 'Otro' }
  ]]


  
  export {POSITION,AREA} 
